import React from 'react'
import { History } from 'history'
import { inject } from 'mobx-react'
import { AnimatePresence, motion } from 'framer-motion'
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { AddPhotosStore, ADD_PHOTOS_STORE } from '../../stores/AddPhotosStore'
import AlbumModel from '../../models/album'
import { useDropZoneWrapper } from './DropZoneWrapper.hook'

interface DropZoneWrapperProps {
  children: React.ReactNode
  workspaceId: string
  workspaceSlug: string
  history: History
  albumId?: string
  album?: AlbumModel
  [ADD_PHOTOS_STORE]?: AddPhotosStore
}

const DropZoneWrapper: React.FC<DropZoneWrapperProps> = ({
  children,
  workspaceId,
  workspaceSlug,
  history,
  albumId,
  album,
  ...props
}) => {
  const { t } = useTranslation()
  const addPhotosStore = props[ADD_PHOTOS_STORE]

  const { getRootProps, getInputProps, isDragActive } = useDropZoneWrapper({
    addPhotosStore,
    workspaceId,
    workspaceSlug,
    history,
    albumId,
    album,
  })

  return (
    <div {...getRootProps()} className="relative min-h-0">
      <input {...getInputProps()} />

      {children}

      <AnimatePresence>
        {isDragActive && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.15 }}
              className="flex flex-col items-center gap-4 rounded-2xl border-2 border-dashed border-indigo-400 bg-white/90 px-16 py-12 shadow-lg"
            >
              <div className="rounded-full bg-indigo-50 p-4">
                <ArrowUpTrayIcon className="h-10 w-10 text-indigo-500" />
              </div>
              <p className="text-lg font-medium text-gray-800">
                {t('dropZone.dropHere')}
              </p>
              <p className="text-sm text-gray-400">
                {t('dropZone.supportedFormats')}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default inject(ADD_PHOTOS_STORE)(DropZoneWrapper)
